<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>
        <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">
          <div style="margin-left: 20px;">
            <v-tabs v-model="activeTab" centered>
              <v-tab :key="1">21 окт. (вторник)</v-tab>
              <v-tab :key="2">22 окт. (среда)</v-tab>
              <v-tab :key="3">23 окт. (четверг)</v-tab>
              <v-tab :key="4">24 окт. (пятница)</v-tab>
            </v-tabs>
          </div>
        </v-card-title>

        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="1">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">8:00 - 12:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Регистрация участников и гостей Форума</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл первого этажа Дома ученых</b>
                </div>
                <b class="prog-text">Приветственный кофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">9:00 - 12:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Сбор гостей на экскурсию, экскурсия по инфраструктуре центра</b>
              </v-col>
            </v-row>
            <hr>


            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:00 - 15:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 18px;">Пленарная сессия</b>
                <br>
                <!-- <b class="prog-text" style="font-size: 18px;">«Природоподобные технологии: отраслевое применение» </b>
                <br> -->
                <b class="prog-text ml-6" style="font-size: 16px;">Модератор: Ковальчук Михаил Валентинович,</b>
                <br>
                <b class="prog-text ml-6" style="font-size: 16px;">Президент НИЦ «Курчатовский институт»</b>
                <br>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
              </v-col>
            </v-row>

            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:00 - 16:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Торжественный кофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:00 - 20:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 18px;">Научно-практический симпозиум по структурной биологии </b>
                <br>
                <b class="prog-text ml-6" style="font-size: 16px;">Модераторы: Самыгина В.Р., Усачев К.С.</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
              </v-col>
            </v-row>

          </v-tab-item>

          <v-tab-item :key="2">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">9:30 - 11:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Функциональные материалы, катализаторы, магнитные материалы
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Чумаков Ратибор Григорьевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr1_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Теория, моделирование, вычислительные методы
                    </b>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr2_sl1-2'">подробнее
                    </v-btn>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Николаев Константин Владимирович</p>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Школа молодых учёных «Современные подходы к созданию детекторных материалов»
                    </b>
                    <br>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr3_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:00 - 11:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:30 - 13:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Функциональные материалы, катализаторы, магнитные материалы
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Чумаков Ратибор Григорьевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr1_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Теория, моделирование, вычислительные методы
                    </b>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr2_sl1-2'">подробнее
                    </v-btn>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Николаев Константин Владимирович</p>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Школа молодых учёных «Современные подходы к созданию детекторных материалов»
                    </b>
                    <br>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr3_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">13:00 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">ПЕРЕРЫВ</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:00 - 15:10</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="12">
                    <b class="prog-text" style="font-size: 16px;">Эксперименты In-situ, in-operando, накачка-зондирование
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Якунин Сергей Николаевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr1_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <!-- <v-col lg="6">
                    <b class="prog-text" style="font-size: 16px;">Электронная, ионная и конфокальная микроскопия
                    </b>
                    <br>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:10 - 15:40</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:40 - 16:50</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="12">
                    <b class="prog-text" style="font-size: 16px;">Эксперименты In-situ, in-operando, накачка-зондирование
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Якунин Сергей Николаевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd1_tr1_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <!-- <v-col lg="6">
                    <b class="prog-text" style="font-size: 16px;">Электронная, ионная и конфокальная микроскопия
                    </b>
                    <br>
                  </v-col> -->
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:50 - 18:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Постерная сессия</b>
                <br>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 'poster_1'">подробнее
                </v-btn>
              </v-col>
            </v-row>
            <!-- <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:30 - 21:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Фуршет</b>
              </v-col>
            </v-row> -->
            <hr>
          </v-tab-item>

          <v-tab-item :key="3">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">9:30 - 11:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Аппаратурно-методические аспекты синхротронных и нейтронных экспериментов
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Рогачев Александр Владимирович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr1_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Биологические системы, полимеры, вещество в мягком конденсированном состоянии
                    </b>
                    <p class="prog-text ml-6 mb-1">Председатель: Новикова Наталья Николаевна</p>
                    <br>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr2_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Школа молодых учёных «Современные подходы к созданию детекторных материалов»
                    </b>
                    <br>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr3_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:00 - 11:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:30 - 13:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Аппаратурно-методические аспекты синхротронных и нейтронных экспериментов
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Рогачев Александр Владимирович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr1_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Биологические системы, полимеры, вещество в мягком конденсированном состоянии
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Новикова Наталья Николаевна</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr2_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                 </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Школа молодых учёных «Современные подходы к созданию детекторных материалов»
                    </b>
                    <br>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr3_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">13:00 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">ПЕРЕРЫВ</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:00 - 15:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Аппаратурно-методические аспекты синхротронных и нейтронных экспериментов
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Рогачев Александр Владимирович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr1_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Биологические системы, полимеры, вещество в мягком конденсированном состоянии
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Новикова Наталья Николаевна</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr2_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Электронная, ионная и конфокальная микроскопия
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Авилов Анатолий Сергеевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr3_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:30 - 16:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:00 - 17:20</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Аппаратурно-методические аспекты синхротронных и нейтронных экспериментов
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Рогачев Александр Владимирович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr1_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Биологические системы, полимеры, вещество в мягком конденсированном состоянии
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Новикова Наталья Николаевна</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr2_sl1-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Электронная, ионная и конфокальная микроскопия
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Авилов Анатолий Сергеевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd2_tr3_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:20 - 18:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Постерная сессия</b>
                <br>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 'poster_2'">подробнее
                </v-btn>

              </v-col>
            </v-row>
            <hr>

          </v-tab-item>

          <v-tab-item :key="4">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">9:30 - 11:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Материаловедение и индустриальные задачи
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Велигжанин Алексей Александрович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr1_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Синхротронная и нейтронная визуализация
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Подурец Константин Михайлович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr2_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Электронная, ионная и конфокальная микроскопия
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Васильев А.Л.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr3_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:00 - 11:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:30 - 13:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Материаловедение и индустриальные задачи
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Велигжанин Алексей Александрович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr1_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Синхротронная и нейтронная визуализация
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Подурец Константин Михайлович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr2_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Электронная, ионная и конфокальная микроскопия
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Васильев А.Л.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr3_sl1-2'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">13:00 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">ПЕРЕРЫВ</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:00 - 15:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Поверхность, интерфейсы, тонкие пленки
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Субботин Илья Александрович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr1_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Современные задачи экологии, структурной химии, радиохимии
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Светогоров Роман Дмитриевич</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr2_sl3'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">театральная студия</b>
                    </div>
                  </v-col>

                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 16px;">Круглый стол «Компактные источники нейтронов»
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Кулевой Тимур Вячеславович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr3_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:30 - 16:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:00 - 17:10</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg="6">
                    <b class="prog-text" style="font-size: 16px;">Поверхность, интерфейсы, тонкие пленки
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Субботин Илья Александрович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr1_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="6">
                    <b class="prog-text" style="font-size: 16px;">Круглый стол «Компактные источники нейтронов»
                    </b>
                    <br>
                    <p class="prog-text ml-6 mb-1">Председатель: Кулевой Тимур Вячеславович</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 'd3_tr3_sl3-4'">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">студия игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:15 - 18:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 18px;">Лекция «Синхротронные и нейтронные исследования РФ» </b>
                <br>
                    <p class="prog-text ml-6 mb-1">Марченков Никита Владимирович</p>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">18:00 - 20:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Закрытие форума, фуршет</b>
              </v-col>
            </v-row>
            <hr>

          </v-tab-item>
        </v-tabs-items>
      </v-card>


    <v-dialog v-model="details_modal" max-width="60%">
      <v-card class="pa-2">
        <div v-if="details_type == 'd1_tr1_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Функциональные материалы, катализаторы, магнитные материалы</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">22 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s1_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s1_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd1_tr2_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Теория, моделирование, вычислительные методы</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">22 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s2_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s2_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd1_tr3_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Школа молодых учёных «Современные подходы к созданию детекторных материалов»</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">22 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">9:00 - 9:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Регистрация участников</b></p>
              </v-col>
            </v-row>

            <div v-for="item in details_school_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text mb-0 ml-12" style="font-size: 14px;" v-if="item.subheader1">{{ item.subheader1 }}</p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader2">{{ item.subheader2 }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_school_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text mb-0 ml-12" style="font-size: 14px;" v-if="item.subheader1">{{ item.subheader1 }}</p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader2">{{ item.subheader2 }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd2_tr3_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Школа молодых учёных «Современные подходы к созданию детекторных материалов»</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">23 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_school_3">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text mb-0 ml-12" style="font-size: 14px;" v-if="item.subheader1">{{ item.subheader1 }}</p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader2">{{ item.subheader2 }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_school_4">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text mb-0 ml-12" style="font-size: 14px;" v-if="item.subheader1">{{ item.subheader1 }}</p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader2">{{ item.subheader2 }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd1_tr1_sl3-4'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Эксперименты In-situ, in-operando, накачка-зондирование</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">22 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s3_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:10 - 15:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s3_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd2_tr1_sl1-4'">
          <v-card-title class="headline flex-wrap">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Аппаратурно-методические аспекты синхротронных и нейтронных экспериментов</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">23 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s4_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s4_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:10 - 14:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>ПЕРЕРЫВ</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s4_3">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s4_4">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd2_tr2_sl1-4'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Биологические системы, полимеры, вещество в мягком конденсированном состоянии</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">23 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s5_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s5_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:00 - 14:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>ПЕРЕРЫВ</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s5_3">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s5_4">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd2_tr3_sl3-4'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Электронная, ионная и конфокальная микроскопия</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">23 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s6_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:40 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s6_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd3_tr1_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Материаловедение и индустриальные задачи</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">24 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s7_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s7_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd3_tr2_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Синхротронная и нейтронная визуализация</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">24 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s8_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:50 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s8_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd3_tr3_sl1-2'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Электронная, ионная и конфокальная микроскопия</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">24 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s9_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s9_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd3_tr1_sl3-4'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
              <p>Поверхность, интерфейсы, тонкие пленки</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">24 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s10_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:40 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s10_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd3_tr3_sl3-4'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
              <p>Компактные источники нейтронов</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">24 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s12_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <div v-for="item in details_s12_2">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'd3_tr2_sl3'">
          <v-card-title class="headline">
            <v-row>
              <v-col cols="12" lg="8">
                <p>Современные задачи экологии, структурной химии, радиохимии</p>
              </v-col>
              <v-col cols="12" lg="4" class="pt-6" style="text-align: right !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-calendar</v-icon>
                  </v-avatar>
                  <b style="color:white;">24 октября 2025г.</b>
                </v-chip>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div v-for="item in details_s11_1">
              <hr>
              <v-row>
                <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-clock-time-eight</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{  item.time }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.header }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;" v-if="item.subheader">{{ item.subheader }}</p>
                  <p class="prog-text" style="font-size: 14px;" v-if="item.main"><b>{{ item.main }}</b></p>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </div>

        <div v-if="details_type == 'poster_1'">
          <v-card-title class="headline">
            <p>Постерная сессия 1</p>
          </v-card-title>

          <v-card-text>
            <template v-for="post_section in poster_sections_d1">
              <p class="prog-text ml-6 mb-0" style="font-size: 18px; color:#ae24c3;"><b>{{ post_section.descr }}</b></p>
              <div v-for="item in posters_day1" v-if="item.section_confirm_id == post_section.id">
                <hr>
                <v-row>
                  <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <b style="color:white;">П{{  item.speak_slot }}</b>
                    </v-chip>
                  </v-col>
                  <v-col>
                    <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.user_descr }}</b></p>
                    <p class="prog-text" style="font-size: 14px;" v-if="item.comments"><b>{{ item.comments }}</b></p>
                  </v-col>
                </v-row>
              </div>
            </template>
          </v-card-text>
        </div>

        <div v-if="details_type == 'poster_2'">
          <v-card-title class="headline">
            <p>Постерная сессия 2</p>
          </v-card-title>

          <v-card-text>
            <template v-for="post_section in poster_sections_d2">
              <p class="prog-text ml-6 mb-0" style="font-size: 18px; color:#ae24c3;"><b>{{ post_section.descr }}</b></p>
              <div v-for="item in posters_day2" v-if="item.section_confirm_id == post_section.id">
                <hr>
                <v-row>
                  <v-col style="max-width: 150px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <b style="color:white;">П{{  item.speak_slot }}</b>
                    </v-chip>
                  </v-col>
                  <v-col>
                    <p class="prog-text ml-6 mb-0" style="font-size: 18px;"><b>{{ item.user_descr }}</b></p>
                    <p class="prog-text" style="font-size: 14px;" v-if="item.comments"><b>{{ item.comments }}</b></p>
                  </v-col>
                </v-row>
              </div>
            </template>
          </v-card-text>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="details_modal = false">закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>

import { mapActions } from 'vuex';

export default {
  name: 'Program_25',

  data() {
    return {
      activeTab: 0,
      details_modal: false,
      details_type: '',

      poster_sections_d1: [
        {id: 30, descr: 'Секция «Синхротронная и нейтронная визуализация»'},
        {id: 29, descr: 'Секция «Современные задачи экологии, структурной химии, радиохимии»'},
        {id: 34, descr: 'Секция «Теория, моделирование, вычислительные методы»'},
        {id: 26, descr: 'Секция «Функциональные материалы, катализаторы, магнитные материалы»'},
        {id: 27, descr: 'Секция «Эксперименты In-situ, In-operando, Накачка-Зондирование»'},
      ],
      poster_sections_d2: [
        {id: 33, descr: 'Секция «Аппаратурно методические аспекты синхротронных и нейтронных экспериментов»'},
        {id: 28, descr: 'Секция «Биологические системы, Полимеры, Вещество в мягком конденсированном состоянии»'},
        {id: 31, descr: 'Секция «Материаловедение и индустриальные задачи»'},
        {id: 32, descr: 'Секция «Поверхность, Интерфейсы, Тонкие пленки»'},
        {id: 35, descr: 'Секция «Электронная, ионная и конфокальная микроскопия»'},
        {id: 37, descr: 'Секция «Компактные источники нейтронов»'},
      ],

      posters_day1: [],
      posters_day2: [],

      details_school_1: [
        {
          id: 1,
          time: '09:30 - 09:35',
          header: 'Егоров Антон Сергеевич, к.х.н.',
          subheader1: 'Руководитель Курчатовского комплекса физико-химических технологий',
          subheader2: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          main: 'Вступительное слово',
        },
        {
          id: 2,
          time: '09:35 - 10:00',
          header: 'М.В. Коржик, д.ф.-м.н., профессор',
          subheader1: 'НИЦ «Курчатовский институт», г. Москва, Россия;',
          subheader2: 'Институт Ядерных Проблем БГУ, г. Минск, Беларусь',
          main: '«Сцинтилляционные детекторы — основа ядерно-физических измерений»',
        },
        {
          id: 3,
          time: '10:00 - 10:30',
          header: 'А.Н. Васильев, д.ф.-м.н., профессор',
          subheader1: 'МГУ им. М.В. Ломоносова;',
          subheader2: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          main: '«Физические основы создания сцинтилляционных материалов нового поколения»',
        },
        {
          id: 4,
          time: '10:30 - 11:00',
          header: 'В.А. Пустоваров, д.ф.-м.н., профессор',
          subheader1: 'Уральский федеральный университет, г. Екатеринбург, Россия',
          main: '«Спектроскопия редкоземельных ионов в люминесцентных материалах»',
        },
      ],

      details_school_2: [
        {
          id: 1,
          time: '11:30 - 12:00',
          header: 'И.А. Каменских, к.ф.-м.н., доцент',
          subheader1: 'МГУ им. М.В. Ломоносова, г. Москва, Россия',
          main: '«Синхротронные методы для исследования современных детекторных материалов»',
        },
        {
          id: 2,
          time: '12:00 - 12:30',
          header: 'М.Д. Скорохватов, д.ф.-м.н., профессор',
          subheader1: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          main: '«Роль сцинтилляционных материалов в изучении физики нейтрино»',
        },
        {
          id: 3,
          time: '12:30 - 13:00',
          header: 'И.Ю. Комендо, к.х.н., доцент',
          subheader1: 'НИЦ «Курчатовский институт»;',
          subheader2: 'РХТУ им. Д.И. Менделеева, г. Москва, Россия',
          main: '«Легкие неорганические сцинтилляционные материалы для детектирования нейтронов»',
        },
      ],

      details_school_3: [
        {
          id: 1,
          time: '09:30 - 10:00',
          header: 'П.В. Карпюк, к.х.н.',
          subheader1: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          main: '«Передовые подходы в разработке прозрачной керамики для детектирования ионизирующих излучений»',
        },
        {
          id: 2,
          time: '10:00 - 10:30',
          header: 'П.С. Соколов, к.х.н.',
          subheader1: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          main: '«3D печать как способ создания позиционно-чувствительных элементов детекторов излучения»',
        },
        {
          id: 3,
          time: '10:30 - 11:00',
          header: 'Р.Р.Сайфутяров, к.х.н.',
          subheader1: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          main: '«Инструментальные методы анализа современных детекторных материалов»',
        },
      ],

      details_school_4: [
        {
          id: 1,
          time: '11:30 - 12:00',
          header: 'В.А.Мечинский , к.ф.-м.н.',
          subheader1: 'НИЦ «Курчатовский институт», г. Москва, Россия',
          subheader2: 'Институт Ядерных Проблем БГУ, г. Минск, Беларусь',
          main: '«Регистрация нейтронов в широком энергетическом диапазоне»',
        },
        {
          id: 2,
          time: '12:00 - 12:30',
          header: 'В.Н.Корнаухов, к.ф.-м.н.',
          subheader1: 'НИЯУ МИФИ, г. Москва, Россия',
          main: '«Изотопно-обогащенные сцинтиляторы и их применение в фундаментальной физике»',
        },
        {
          id: 3,
          time: '12:30 - 13:00',
          header: 'В.Н.Шлегель, к.х.н., доцент',
          subheader1: 'Институт неорганической химии им. А.В.Николаева СО РАН, г.Новосибирск, Россия',
          main: '«Расплавные методы получения сцинтилляционных кристаллов»',
        },
      ],

      details_s1_1: [
        {
          id: 1,
          time: '09:30 - 09:50',
          header: 'Биляченко Алексей Николаевич',
          subheader: 'ИНЭОС РАН',
          main: '«Каркасные металлосил- и гермсесквиоксаны: особенности структурирования и функциональных свойств»',
        },
        {
          id: 2,
          time: '09:50 - 10:10',
          header: 'Якушев Илья Аркадьевич',
          subheader: 'ИОНХ РАН',
          main: '«Синтез и исследование каталитических свойств биметаллических наноматериалов на основе палладия и платины»',
        },
        {
          id: 3,
          time: '10:10 - 10:30',
          header: 'Вахрушев Сергей Борисович',
          subheader: 'ФТИ им. А.Ф. Иоффе',
          main: '«Критическая динамика сегнетоэлектриков из диффузного рассеяния»',
        },
        {
          id: 4,
          time: '10:30 - 10:50',
          header: 'Ковалев Александр Денисович',
          subheader: 'НИТУ МИСИС',
          main: '«Магнитные свойства и катионное распределение в структуре легированных ферритов (Zn, Cr, Co, Fe)3O4 для применения в биомедицине»',
        },
        {
          id: 5,
          time: '10:50 - 11:10',
          header: 'Еремина Рушана Михайловна',
          subheader: 'КНЦ РАН',
          main: '«Структурные и магнитные свойства Co2.19Mn0.81BO5»',
        },
      ],

      details_s1_2: [
        {
          id: 1,
          time: '11:30 - 11:50',
          header: 'Турищев Сергей Юрьевич',
          subheader: 'ВГУ',
          main: '«Исследования биогибридных материалов на основе молекул Dps клеток E.coli методами рентгеновской и электронной спектроскопии и микроскопии, в том числе синхротронными»',
        },
        {
          id: 2,
          time: '11:50 - 12:10',
          header: 'Дубинский Сергей Михайлович',
          subheader: 'НИТУ МИСИС',
          main: '«Экспериментальное подтверждение гипотезы существования квази-ОЦК на примере сплава Ti-Nb-Zr с естественным элинварным эффектом: предварительные результаты»',
        },
        {
          id: 3,
          time: '12:10 - 12:30',
          header: 'Крымская Ольга Александровна',
          subheader: 'МИФИ',
          main: '«Исследование кристаллографической текстуры образцов труб из сплава на основе циркония с использованием дифракции нейтронов»',
        },
        {
          id: 4,
          time: '12:30 - 12:50',
          header: 'Кузнецова Татьяна Владимировна',
          subheader: 'ИФМ УрО РАН',
          main: '«Применение резонансной рентгеновской фотоэмиссионной спектроскопии для изучения локальных электронных характеристик многокомпонентных функциональных материалов с использованием синхротронного излучения»',
        },
      ],

      details_s2_1: [
        {
          id: 1,
          time: '09:30 - 09:50',
          header: 'Горай Леонид Иванович',
          subheader: 'СПБАУ им. Алфёрова',
          main: '«Метод граничных интегральных уравнений для строгого анализа интенсивности рентгеновского рассеяния на дифракционных решетках, многослойных зеркалах и зонных пластинках»',
        },
        {
          id: 2,
          time: '09:50 - 10:20',
          header: 'Бочев Михаил Александрович',
          subheader: 'ИВМ РАН',
          main: '«О решении параметрических квадратичных задач на собственные значения при изучении рассеяния монохроматических волн»',
        },
        {
          id: 3,
          time: '10:20 - 10:40',
          header: 'Николаев Константин Владимирович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Диффузное рассеяние рентгеновского излучения на шероховатости стенок периодических наноструктур»',
        },
        {
          id: 4,
          time: '10:40 - 11:00',
          header: 'Титов Анатолий Игоревич',
          subheader: 'НИЦ «Курчатовский институт» – ПИЯФ',
          main: '«Базовые алгоритмы анализа данных молекулярной динамики: методы пространственного наложения»',
        },
      ],

      details_s2_2: [
        {
          id: 1,
          time: '11:30 - 11:50',
          header: 'Щербаков Алексей Александрович',
          subheader: 'ИТМО',
          main: '«Высокоэффективные проекционные методы моделирования дифракции на решетках»',
        },
        {
          id: 2,
          time: '11:50 - 12:10',
          header: 'Савченков Павел Сергеевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Применение байесовского анализа для интерпретации данных рефлектометрии поляризованных нейтронов»',
        },
        {
          id: 3,
          time: '12:10 - 12:40',
          header: 'Проценко Богдан Олегович',
          subheader: 'ЮФУ',
          main: '«ИИ агенты и экспериментальные библиотеки для анализа данных спектроскопии поглощения»',
        },
        {
          id: 4,
          time: '12:40 - 13:00',
          header: 'Корлюков Александр Александрович',
          subheader: 'ИНЭОС РАН',
          main: '«Изучение распределения электронной плотности для установления особенностей механизма фармакологического действия»',
        },
      ],

      details_s3_1: [
        {
          id: 1,
          time: '14:00 - 14:30',
          header: 'Зенкевич Андрей Владимирович',
          subheader: 'МФТИ',
          main: '«Синхротронные спектроскопические исследования in operando на прототипах перспективных устройств наноэлектроники и спинтроники»',
        },
        {
          id: 2,
          time: '14:30 - 14:50',
          header: 'Федотов Станислав Сергеевич',
          subheader: 'СколТех',
          main: '«Operando дифракционные и спектроскопические исследования электродных материалов для металл-ионных аккумуляторов»',
        },
        {
          id: 3,
          time: '14:50 - 15:10',
          header: 'Гуда Александр Александрович',
          subheader: 'ЮФУ',
          main: '«Инструменты для скрининга и оптимизации параметров химических реакций: переход к самоуправляемым лабораториям»',
        },
      ],

      details_s3_2: [
        {
          id: 1,
          time: '15:40 - 16:10',
          header: 'Иванов Дмитрий Анатольевич',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«Современные in-situ методы сиспользованием микро- и нано-фокусного рентгеновского рассеяни»',
        },
        {
          id: 2,
          time: '16:10 - 16:30',
          header: 'Мареев Евгений Игоревич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Лазерно-индуцированная структурная динамика в кристаллах: исследования с использованием класса методов «оптическая накачка – зондирование синхротронным пучком»',
        },
        {
          id: 3,
          time: '16:30 - 16:50',
          header: 'Гурьева Светлана Анатольевна',
          subheader: 'ФТИ им. А.Ф. Иоффе',
          main: '«Исследование полиморфных превращений н-алкана при нагревании с помощью синхротронного излучения»',
        },
      ],

      details_s4_1: [
        {
          id: 1,
          time: '09:30 - 10:10',
          header: 'Полковников Владимир Николаевич',
          subheader: 'ИФМ РАН',
          main: '«Многослойные зеркала для синхротронных и нейтронных приложений»',
        },
        {
          id: 2,
          time: '10:10 - 10:40',
          header: 'Тарнавич Владислав Валерьевич',
          subheader: 'НИЦ «Курчатовский институт» – ПИЯФ',
          main: '«Вопросы импортозамещения приборного комплекса реактора ПИК»',
        },
        {
          id: 3,
          time: '10:40 - 11:00',
          header: 'Запуниди Сергей Александрович',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«Прецизионный датчик положения и интенсивности пучка синхротронного излучения на основе тонкой пластины монокристаллического алмаза»',
        },
      ],

      details_s4_2: [
        {
          id: 1,
          time: '11:30 - 12:10',
          header: 'Боднарчук Виктор Иванович',
          subheader: 'ОИЯИ',
          main: '«Представление проекта «Развитие аппаратно-методической базы для решения научных и прикладных задач на источниках нейтронов разного типа»',
        },
        {
          id: 2,
          time: '12:10 - 12:30',
          header: 'Сараев Андрей Александрович',
          subheader: 'ИК СО РАН',
          main: '«Научная программа и исследовательские станции ЦКП СКИФ»',
        },
        {
          id: 3,
          time: '12:30 - 12:50',
          header: 'Пиминов Павел Алексеевич',
          subheader: 'ЦКП СКИФ ИК СО РАН',
          main: '«Статус и перспективы ускорительного комплекса источника синхротронного излучения ЦКП СКИФ»',
        },
        {
          id: 4,
          time: '12:50 - 13:10',
          header: 'Комлев Алексей Степанович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Экспериментальные методики контроля магнитных свойств ондуляторов на постоянных магнитах для накопителя «СИЛА»',
        },
      ],

      details_s4_3: [
        {
          id: 1,
          time: '14:00 - 14:30',
          header: 'Гоголев Алексей Сергеевич',
          subheader: 'ТПУ',
          main: '«Метрологическое обеспечение измерительных методик с использованием синхротронных источников при решении нефтегазовых задач»',
        },
        {
          id: 2,
          time: '14:30 - 14:50',
          header: 'Пруцков Григорий Владимирович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Внедрение системы Tango Controls для управления экспериментальными станциями синхротрона «Сибирь-2» и исследовательского ядерного реактора ИР-8»',
        },
        {
          id: 3,
          time: '14:50 - 15:10',
          header: 'Архипов Сергей Григорьевич',
          subheader: 'ИК СО РАН',
          main: '«Потенциал ЦКП СКИФ в области структурной биологии»',
        },
        {
          id: 4,
          time: '15:10 - 15:30',
          header: 'Трофимов Михаил Сергеевич',
          subheader: 'ТГУ',
          main: '«Особенности взаимодействия синхротронного излучения с сенсорами на основе арсенида галлия, компенсированного хромом»',
        },
      ],

      details_s4_4: [
        {
          id: 1,
          time: '16:00 - 16:30',
          header: 'Фоломешкин Максим Сергеевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Высокоразрешающая рентгеновская микроскопия с использованием кремниевых нанофокусирующих линз на «КИСИ-Курчатов»',
        },
        {
          id: 2,
          time: '16:30 - 17:00',
          header: 'Баранников Александр Александрович',
          subheader: 'БФУ им. И. Канта',
          main: '«Кремниевая планарная преломляющая оптика для когерентных источников рентгеновского излучения»',
        },
        {
          id: 3,
          time: '17:00 - 17:30',
          header: 'Студенников Алексей Александрович',
          subheader: 'ИГиЛ СО РАН',
          main: '«Разработка быстрого затвора рентгеновского излучения для станций синхротронного исследования быстрых процессов»',
        },
      ],

      details_s5_1: [
        {
          id: 1,
          time: '09:30 - 10:10',
          header: 'Волков В.В.',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Теоретические основы и особенности аппаратуры метода малоуглового рентгеновского и нейтронного рассеяния в исследовании строения биополимерных систем»',
        },
        {
          id: 2,
          time: '10:10 - 10:40',
          header: 'Конарев П.В.',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Возможности программного пакета ATSAS для исследования структуры биологических систем в растворах по данным малоуглового рассеяния»',
        },
        {
          id: 3,
          time: '10:40 - 11:00',
          header: 'Самыгина В.Р.',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Структура химерного рекомбинантного белка с пероксидазной и супероксиддисмутазной активностью»',
        },
      ],

      details_s5_2: [
        {
          id: 1,
          time: '11:30 - 11:50',
          header: 'Марченкова Маргарита Александровна',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Кластеры-прекурсоры в кристаллизационных растворах белков: совместный анализ малоуглового рассеяния и молекулярной динамики»',
        },
        {
          id: 2,
          time: '11:50 - 12:10',
          header: 'Армеев Григорий Алексеевич',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«Исследование откручивания ДНК от нуклеосомы напоследовательности Widom 603 сиспользованием Крио-ЭМ и МУРР»',
        },
        {
          id: 3,
          time: '12:10 - 12:30',
          header: 'Власов Алексей Валерьевич',
          subheader: 'МФТИ',
          main: '«Контроль сборки белковых наночастиц с помощью малоуглового рентгеновского рассеяния и электронной микроскопии»',
        },
        {
          id: 4,
          time: '12:30 - 13:00',
          header: 'Белушкин Александр Владиславович',
          subheader: 'НИЦ «Курчатовский институт», ОИЯИ',
          main: '«Зачем нужны нейтроны в биологии и археологии»',
        },
      ],

      details_s5_3: [
        {
          id: 1,
          time: '14:00 - 14:30',
          header: 'Новикова Наталья Николаевна',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Рентгеновские исследования двумерных наносистем на поверхности жидкости. Возможности экспериментальной станции «Ленгмюр» Курчатовского источника синхротронного излучения»',
        },
        {
          id: 2,
          time: '14:30 - 14:50',
          header: 'Малахова Юлия Николаевна',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Особенности структурообразования полимеров в ленгмюровских слоях: от монослоев, к мезоморфным полислоям и 3D кристаллизации»',
        },
        {
          id: 3,
          time: '14:50 - 15:10',
          header: 'Казак Александр Васильевич',
          subheader: 'ИвГУ',
          main: '«Надмолекулярная организация производных фталоцианина в плавающих слоях и тонких пленках»',
        },
        {
          id: 4,
          time: '15:10 - 15:30',
          header: 'Аракчеев Андрей Владимирович',
          subheader: 'ИФХЭ РАН',
          main: '«Самосборка координационного полимера на основе тетрапиррольных комплексов никеля(ii) и рутения(ii) на межфазной поверхности»',
        },
      ],

      details_s5_4: [
        {
          id: 1,
          time: '16:00 - 16:20',
          header: 'Балашою Мария Александровна',
          subheader: 'ОИЯИ',
          main: '«Малоугловое рассеяние нейтронов и рентгеновских лучей новых типов феррожидкостей для агнитооптических приложений»',
        },
        {
          id: 2,
          time: '16:20 - 16:40',
          header: 'Копица Геннадий Петрович',
          subheader: 'НИЦ «Курчатовский институт» – ПИЯФ',
          main: '«Структура полимерных аэрогелей, получаемых растворением полиамида 6,6»',
        },
        {
          id: 3,
          time: '16:40 - 17:00',
          header: 'Бакиров Артем Вадимович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Кристаллизация карбосилановых дендримеров высоких генераций: от заполнения пространства к плотной упаковке»',
        },
      ],

      details_s6_1: [
        {
          id: 1,
          time: '14:00 - 14:10',
          header: 'Авилов Анатолий Сергеевич',
          main: 'Вступительное слово',
        },
        {
          id: 2,
          time: '14:10 - 14:40',
          header: 'Ищенко Анатолий Александрович',
          subheader: 'РТУ МИРЭА',
          main: '«Развитие метода ультрабыстрой электронной микроскопии»',
        },
        {
          id: 3,
          time: '14:40 - 15:10',
          header: 'Петров Алексей Сергеевич',
          subheader: 'ИФП СО РАН',
          main: '«In-situ отражательная электронная микроскопия для исследования процессов сублимации, травления, электромиграции, адсорбции металлов и эпитаксиального роста на поверхностях кремния и карбида кремния»',
        },
        {
          id: 4,
          time: '15:10 - 15:40',
          header: 'Шкловер Владимир Яковлевич',
          subheader: 'ООО «Системы для микроскопии и анализа»',
          main: '«Применение современных методов рентгеновской и электронной микроскопии в исследовании структуры и свойств горных пород»',
        },
      ],

      details_s6_2: [
        {
          id: 1,
          time: '16:00 - 16:25',
          header: 'Боргардт Николай Иванович',
          subheader: 'НИУ МИЭТ',
          main: '«Распыление фокусированным ионным пучком бинарных материалов и многослойных структур в краевом режиме»',
        },
        {
          id: 2,
          time: '16:25 - 16:45',
          header: 'Васильев Александр Леонидович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Структурные преобразования в пленках NiO после отжига»',
        },
        {
          id: 3,
          time: '16:45 - 17:05',
          header: 'Приходько Александр Сергеевич',
          subheader: 'НИУ МИЭТ',
          main: '«Распределение атомов в окрестности дислокации несоответствия между подложкой кремния и эпитаксиальным слоем Ge-Sb-Te»',
        },
        {
          id: 4,
          time: '17:05 - 17:25',
          header: 'Соколов Леонид Владимирович',
          subheader: 'АО «РПКБ»',
          main: '«Исследование распределения остаточных напряжений на рельефной поверхности МЭМС-КНИМТ чипа тензопреобразователя давленияметодом Рамановской спектроскопии»',
        },
      ],

      details_s7_1: [
        {
          id: 1,
          time: '09:30 - 10:00',
          header: 'Вологжанина Анна Владимировна',
          subheader: 'ИНЭОС РАН',
          main: '«Определение кристаллической структуры активных фармацевтических субстанций методами рентгеновской дифракции»',
        },
        {
          id: 2,
          time: '10:00 - 10:20',
          header: 'Шошев Федор Львович',
          subheader: 'НИЦ «Курчатовский институт» – ВИАМ',
          main: '«Исследование остаточных напряжений в образцах алюмоматричного композиционного материала на основе сплава марки ВАС1 с добавлением частиц WC, полученного методом селективного лазерного сплавления»',
        },
        {
          id: 3,
          time: '10:20 - 10:40',
          header: 'Карпов Иван Дмитриевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Анализ остаточных напряжений в металлических образцах полученных аддитивным способом с использованием метода нейтронной дифракци»',
        },
        {
          id: 4,
          time: '10:40 - 11:00',
          header: 'Федоренко Алексей Николаевич',
          subheader: 'СколТех',
          main: '«Моделирование остаточных напряжений в металлических образцах полученных методом селективного лазерного сплавления»',
        },
      ],

      details_s7_2: [
        {
          id: 1,
          time: '11:30 - 12:00',
          header: 'Солдатов Александр Владимирович',
          subheader: 'ЮФУ',
          main: '«Цифровой постдок» на синхротроне: технологии ИИ для решения задач operando рентгеноспектральной метрологии»',
        },
        {
          id: 2,
          time: '12:00 - 12:20',
          header: 'Волосков Борис Сергеевич',
          subheader: 'СколТех',
          main: '«Экспресс-метод оценки остаточных напряжений в металлических образцах полученных аддитивным способом»',
        },
        {
          id: 3,
          time: '12:20 - 12:40',
          header: 'Сергеичев Иван Валерьевич',
          subheader: 'СколТех',
          main: '«Влияние остаточных напряжений на сверхмногоцикловую усталость образцов коррозионностойкой стали 316L полученных методом селективного лазерного сплавления»',
        },
        {
          id: 4,
          time: '12:40 - 13:00',
          header: 'Мурашев Михаил Михайлович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Нейтронные исследования пластин, изготовленных изкоррозионностойких сталей методом прямого лазерного выращивания»',
        },
      ],

      details_s8_1: [
        {
          id: 1,
          time: '09:30 - 10:10',
          header: 'Зверев Дмитрий Алексеевич (докладчик), Снигирев Анатолий Александрович',
          subheader: 'БФУ им. И. Канта',
          main: '«In-line когерентная рентгеновская оптика: 30 лет спустя»',
        },
        {
          id: 2,
          time: '10:10 - 10:30',
          header: 'Артюков Игорь Анатольевич',
          subheader: 'ФИАН',
          main: '«Рентгеновская микроскопия в спектральном диапазоне «углеродного окна» (длина волны 4.5 - 5 нм)»',
        },
        {
          id: 3,
          time: '10:30 - 10:50',
          header: 'Лобода Анастасия Юрьевна',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Исследование иреконструкция орнаментированной железной накладки изМосковского Кремля»',
        },
      ],

      details_s8_2: [
        {
          id: 1,
          time: '11:30 - 11:50',
          header: 'Гильманов Марат Ирикович',
          subheader: 'ИППИ РАН',
          main: '«Совмещение мультимодальных 3D изображений»',
        },
        {
          id: 2,
          time: '11:50 - 12:10',
          header: 'Бакиров Булат Айратович',
          subheader: 'ОИЯИ',
          main: '«Методы нейтронной ирентгеновской томографии в исследовании археологических артефактов из некрополя Волна 1»',
        },
        {
          id: 3,
          time: '12:10 - 12:30',
          header: 'Кобчикова Полина Павловна',
          subheader: 'ОИЯИ',
          main: '«Сегментация радиографических изображений корневых систем»',
        },
      ],

      details_s9_1: [
        {
          id: 1,
          time: '09:50 - 10:10',
          header: 'Дергалев Александр Андреевич',
          subheader: 'ИНБИ РАН',
          main: '«Структура прионных фибрилл белка Sup35, выделенных из клеток дрожжей, и ее связь с прионным фенотипом»',
        },
        {
          id: 2,
          time: '10:10 - 10:25',
          header: 'Жигалина Ольга Михайловна',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Структура композиций на основе пленок PZT c различными электродными слоями»',
        },
        {
          id: 3,
          time: '10:25 - 10:40',
          header: 'Грешников Эдуард Аркадьевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Исследование фрагмента золотного витого шнура из погребения 18 Спасо-Преображенсого собора (Переславль Залесский) с помощью мультидисциплинар-ных методов»',
        },
        {
          id: 4,
          time: '10:40 - 10:55',
          header: 'Созонтов Евгений Аркадьевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Средневековая новгородская берестяная грамота №1»',
        },
      ],

      details_s9_2: [
        {
          id: 1,
          time: '11:30 - 11:45',
          header: 'Большаков Андрей Михайлович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Влияние отжига на микроструктуру образцов, синтезированных путем горячего прессования монокристалла кремния в порошке кобальта»',
        },
        {
          id: 2,
          time: '11:45 - 12:00',
          header: 'Степович Михаил Адольфович',
          subheader: 'ИВГУ',
          main: '«Морфология и магнитные свойства аморфного сплава (Fe65Co35)2B»',
        },
        {
          id: 3,
          time: '12:00 - 12:15',
          header: 'Фокин Алексей Владимирович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Исследование танталовых катодов, различных производителей, методом электронной микроскопии»',
        },
      ],

      details_s10_1: [
        {
          id: 1,
          time: '14:00 - 14:30',
          header: 'Буравлев Алексей Дмитриевич',
          subheader: 'ФТИ им. А.Ф. Иоффе',
          main: '«Характеризация полупроводниковых сверх-многопериодных GaAs/AlGaAs сверхрешеток»',
        },
        {
          id: 2,
          time: '14:30 - 15:00',
          header: 'Филатова Елена Олеговна',
          subheader: 'СПбГУ',
          main: '«Рентгеновская фотоэлектронная спектроскопия многослойных наноструктур: физика ихимия формирования межслоевых областей»',
        },
        {
          id: 3,
          time: '15:00 - 15:20',
          header: 'Кузьмин Михаил Валерьевич',
          subheader: 'ФТИ им. А.Ф. Иоффе',
          main: '«Исследование свойств адсорбированного слоя кислорода на нанопленке иттербия с помощью метода NEXAFS»',
        },
        {
          id: 4,
          time: '15:20 - 15:40',
          header: 'Асадчиков Виктор Евгеньевич',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Рентгеновская рефлектометрия с учетом рассеяния и дифракции в скользящей геометрии в исследовании твердых ижидких слоистых систем с использованием синхротронного излучения»',
        },
      ],

      details_s10_2: [
        {
          id: 1,
          time: '16:00 - 16:30',
          header: 'Кравцов Евгений Алексеевич',
          subheader: 'ИФМ УрО РАН',
          main: '«Эффекты близости в сверхрешетках Fe/GdHx»',
        },
        {
          id: 2,
          time: '16:30 - 16:50',
          header: 'Пашаев Эльхан Мехрали оглы',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Особенности микроструктры наноразмерных плёнок сложных железосодержащих оксидов»',
        },
        {
          id: 3,
          time: '16:50 - 17:10',
          header: 'Жакетов Владимир Дмитриевич',
          subheader: 'ОИЯИ',
          main: '«Исследование многослойных систем типа ферромагнетик / сверхпроводник»',
        },
      ],

      details_s11_1: [
        {
          id: 1,
          time: '14:00 - 14:30',
          header: 'Романчук Анна Юрьевна',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«От модельных систем к природным объектам: синхротронные методы как инструмент изучения форм и миграции радионуклидов»',
        },
        {
          id: 2,
          time: '14:30 - 14:50',
          header: 'Матвеев Пётр Игоревич',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«Спектроскопия рентгеновского поглощения как инструмент радиохимии: структурные исследования на заключительных стадиях ядерного топливного цикла»',
        },
        {
          id: 3,
          time: '14:50 - 15:10',
          header: 'Фетисов Геннадий Владимирович',
          subheader: 'МГУ им. М.В. Ломоносова',
          main: '«Рентгеноструктурный анализ трудно кристаллизующихся веществ с помощью короткоимпульсного когерентного излучения»',
        },
      ],

      details_s12_1: [
        {
          id: 1,
          time: '14:00 - 14:15',
          header: 'Кулевой Тимур Вячеславович',
          subheader: 'НИЦ «Курчатовский институт»',
          main: '«Компактный источник нейтронов DARIA»',
        },
        {
          id: 2,
          time: '14:15 - 14:30',
          header: 'Кравцов Евгений Алексеевич',
          subheader: 'ИФМ УрО РАН',
          main: '«Компактный источник нейтронов для предприятий реального сектора экономики и академической науки на Урале»',
        },
        {
          id: 3,
          time: '14:30 - 14:45',
          header: 'Григорьев Сергей Валентинович',
          subheader: 'НИЦ «Курчатовский институт» - ПИЯФ',
          main: '«Разработка и прототипирование мишенной сборки для компактного источника нейтронов проекта DARIA»',
        },
        {
          id: 4,
          time: '14:45 - 15:00',
          header: 'Бедретдинов Ильяс Амирович',
          subheader: 'НИЦ «Курчатовский институт» - ПИЯФ',
          main: '«Оптимизация конструкции защиты компактного нейтронного источника с использованием генетического алгоритма»',
        },
        {
          id: 5,
          time: '15:00 - 15:15',
          header: 'Москвин Евгений Владимирович',
          subheader: 'НИЦ «Курчатовский институт» - ПИЯФ',
          main: '«Возможности время-пролетной дифракции нейтронов для исследования процессов в литий-ионных аккумуляторах»',
        },
        {
          id: 6,
          time: '15:15 - 15:30',
          header: 'Павлов Константин Андреевич',
          subheader: 'НИЦ «Курчатовский институт» - ПИЯФ',
          main: '«Установки для исследования крупномасштабных структур на компактном источнике нейтронов»',
        },
      ],

      details_s12_2: [
        {
          id: 1,
          time: '16:00 - 16:15',
          header: 'Изотов Иван Владимирович',
          subheader: 'ИПФ РАН',
          main: '«О следующем этапе модернизации ионного источника  для КИН DARIA»',
        },
        {
          id: 2,
          time: '16:15 - 16:30',
          header: 'Выбин Сергей Сергеевич',
          subheader: 'ИПФ РАН',
          main: '«О следующем этапе модернизации ионного источника  для КИН DARIA»',
        },
        {
          id: 3,
          time: '16:30 - 16:45',
          header: 'Поляков Андрей Вячеславович',
          subheader: 'ИПФ РАН',
          main: '«Моделирование поглощения СВЧ излучения в плазме ионного источника»',
        },
        {
          id: 4,
          time: '16:45 - 17:00',
          header: 'Гаврилов Сергей Александрович',
          subheader: 'ИЯИ РАН',
          main: '«Система диагностики КИН DARIA»',
        },
        {
          id: 5,
          time: '17:00 - 17:15',
          header: 'Коваленко Никита Александрович',
          subheader: 'НИЦ «Курчатовский институт» - ПИЯФ',
          main: '«Концепт мишенной сборки КИН DARIA для пучка протонов с энергий 30-70 МэВ»',
        },
        {
          id: 6,
          time: '17:15 - 17:30',
          header: 'Сидоркин Станислав Федорович',
          subheader: 'ИЯИ  РАН',
          main: '«Мишенные сборки для нейтронных генераторов на основе протонных ускорителей»',
        },
        {
          id: 7,
          time: '17:30 - 17:45',
          header: 'Попов А.',
          subheader: 'ИФМ УрО РАН',
          main: '«Нейросетевой фреймворк для обработки 2D нейтронной дифракции. Алгоритм управления пучком для компактных источников нейтронов»',
        },
        {
          id: 8,
          time: '17:45 - 18:00',
          header: 'Матюхов В.В.',
          subheader: 'ИФМ УрО РАН',
          main: '«Прототип нейтронного детектора на основе фотодиода с конверторным бор-содержащим слоем для КИН»',
        },
      ],
    }
  },

  mounted() {
    this.load_data()
  },

  methods: {
    ...mapActions([
      'GET_LIST_POSTER',
    ]),

    load_data(){
      this.posters_day1 = [];
      this.posters_day2 = [];

      this.GET_LIST_POSTER({meeting_id: 3, type: 'poster_1'})
            .then((res) => {
              this.posters_day1 = res;
            });

      this.GET_LIST_POSTER({meeting_id: 3, type: 'poster_2'})
            .then((res) => {
              this.posters_day2 = res;
            });

    },

  }

  

};
</script>
<style lang="scss" scoped>
  hr{
    margin: 10px;
  }

  .prog-text{
    font-style: italic;
    color:rgb(4, 43, 75);
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
